
export default {
  name: "Element",

  data: function () {
    return {
      isOpen: false
    }
  },

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  methods: {
    openCloseAnswer: function () {
      this.isOpen = !this.isOpen;
    }
  }
}
